import { useState } from "react";
import { MIGRATION } from "../../constants/testIds";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { Input } from "../ui/input";
import { SubmitButton } from "../common/SubmitButton";

// Shared type-to-confirm rollback dialog - used by MigrationHome (list row action) and the
// wizard's Commit step (post-commit action). Rollback posts reversing ledger entries and voids
// migrated members/memberships rather than deleting anything (Tenant Guard forbids hard-delete).
export function RollbackDialog({ open, onOpenChange, onConfirm, pending }) {
  const [text, setText] = useState("");
  return (
    <Dialog open={open} onOpenChange={(v) => { onOpenChange(v); if (!v) setText(""); }}>
      <DialogContent>
        <DialogHeader><DialogTitle>Roll back this migration?</DialogTitle></DialogHeader>
        <p className="text-sm" style={{ color: "var(--scarlet-text-secondary)" }}>
          This posts reversing ledger entries and voids every member/membership this migration created. It does not physically delete anything - the record stays audit-inspectable. Type <strong>ROLLBACK</strong> to confirm.
        </p>
        <div className="space-y-3">
          <Input data-testid={MIGRATION.rollbackConfirmInput} value={text} onChange={(e) => setText(e.target.value)} placeholder="ROLLBACK" />
          <SubmitButton testId={MIGRATION.rollbackConfirmSubmit} disabled={text !== "ROLLBACK"} pending={pending} onClick={onConfirm} fullWidth variant="destructive" label="Confirm rollback" />
        </div>
      </DialogContent>
    </Dialog>
  );
}
